<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="12" class="mt-1">
            <h4>{{ $dt('global.extensions_list_title', 'Extensions') }}</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-checkbox v-model="filterOnlyActive">
              Only Supported
            </b-checkbox>
            <b-checkbox v-model="filterOnlyInactive">
              Only Unsupported
            </b-checkbox>
            <b-checkbox v-model="filters.is_recommended">
              Recommended
            </b-checkbox>
            <b-row class="mb-5">
              <b-col cols="12" md="4" class="mt-2">
                <label for="search">Search</label>
                <b-input v-model="filters.search" name="search" debounce="500" label="Search"/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-table
              :busy="spinners.contentIsLoading"
              :fields="tableFields"
              :items="tableItems"
              bordered
              class="table-sm text-center"
              no-local-sorting
              responsive
              @sort-changed="onSortChanged"
            >
              <template v-slot:cell(id)="{ item }">
                <a :href="item.web_store_url" target="blank">{{item.id}}</a>
              </template>
              <template v-slot:cell(is_active)="{ item }">
                <b-badge :variant="item.is_active ? 'success' : 'danger'" class="d-inline mr-1">{{item.is_active}}</b-badge>
                <b-badge v-if="item.is_recommended" variant="info" class="d-inline">Recommended</b-badge>
              </template>
              <template v-slot:cell(options)="{ item }">
                <router-link :to="{ name: 'ExtensionView', params:{ id: item.id }}">
                  <a><i class="fa fa-eye fa-lg"/></a>
                </router-link>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <!--Paginator-->
          <b-col cols="12" v-if="tableItems.length">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import Services from '@/services';

export default {
  name: 'ExtensionsList',
  components: {
    Pagination
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      filters: {
        search: '',
        sort_by: null,
        sort_order: 'desc',
        is_active: null,
        is_recommended: null,
      },
      tableFields: [
        { key: 'id', label: this.$dt('extension.id', 'Id') },
        { key: 'name', label: this.$dt('extension.name', 'Name'), sortable: true },
        { key: 'is_active', label: this.$dt('extensions.is_active', 'Supported') },
        { key: 'is_recommended', label: this.$dt('extensions.is_recommended', 'Recommended') },
        { key: 'request_count', label: this.$dt('extensions.request_count', 'Times requested'), sortable: true },
        { key: 'created_at', label: this.$dt('extensions.created_at', 'First requested at'), sortable: true },
        { key: 'options', label: this.$dt('extension.options', 'Options') },
      ],
      tableItems: [],
      listPaginator: null,
    };
  },
  computed: {
    filterOnlyActive: {
      get() {
        return this.filters.is_active === 1;
      },
      set(value) {
        if (value) {
          this.filters.is_active = 1;
        } else if (this.filters.is_active !== 0) {
          this.filters.is_active = null;
        }
      }
    },
    filterOnlyInactive: {
      get() {
        return this.filters.is_active === 0;
      },
      set(value) {
        if (value) {
          this.filters.is_active = 0;
        } else if (this.filters.is_active !== 1) {
          this.filters.is_active = null;
        }
      }
    },
    fullFilters() {
      return {
        ...this.filters,
        is_recommended: this.filters.is_recommended ? 1 : null,
        page: this.page,
      };
    },
  },
  watch: {
    fullFilters() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.spinners.contentIsLoading = true;

      Services.extensions.list(this.fullFilters).then(({ data }) => {
        this.tableItems = data.data;
        this.listPaginator = data.meta;
      }).catch(() => {
        this.alertError();
      }).finally(() => {
        this.spinners.contentIsLoading = false;
      });
    },
    onPageChange(page) {
      this.$router.push({ name: 'ExtensionsList', params: { page } });
    },
    getWebstoreUrl(id) {
      return `https://chromewebstore.google.com/detail/${id}`;
    },
    onSortChanged(ctx) {
      Object.assign(this.filters, {
        sort_by: ctx.sortBy,
        sort_order: ctx.sortDesc ? 'desc' : 'asc',
      });
    }
  },
};
</script>
